import { Component, Input, Output, EventEmitter } from '@angular/core';
import { StateService } from '../services/state.service';
import { State } from '../models/state.model';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-state-form',
  templateUrl: './state-form.component.html'
})
export class StateFormComponent {
  constructor(public service: StateService, private notificationService: NotificationService) { }

  @Input() model: State;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  submitted = false;

  ngOnInit() {
    //this.notificationService.showDatePicker();
  }

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.stateID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => {
        console.log(err);
      }
    )
  }
}

